/* Little Feels — Redesign interactions (menu, gallery, sticky ATC, review list) */
(function () {
  'use strict';

  /* Mobile menu */
  document.querySelectorAll('[data-lf-menu-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var menu = document.getElementById('lf-menu');
      if (menu) {
        menu.classList.add('is-open');
        menu.querySelector('[data-lf-menu-close]')?.focus();
      }
    });
  });
  document.querySelectorAll('[data-lf-menu-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.getElementById('lf-menu')?.classList.remove('is-open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.getElementById('lf-menu')?.classList.remove('is-open');
  });

  /* Buy-box gallery: wischbarer Slider, Thumbs springen mit */
  document.querySelectorAll('[data-lf-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-lf-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('.lf-gallery-slide'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-lf-thumb]'));
    var strip = gallery.querySelector('.lf-buybox__thumbs');

    function setActive(i) {
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      var t = thumbs[i];
      if (t && strip) {
        var l = t.offsetLeft, r = l + t.offsetWidth;
        if (l < strip.scrollLeft) strip.scrollTo({ left: l - 10, behavior: 'smooth' });
        else if (r > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: r - strip.clientWidth + 10, behavior: 'smooth' });
      }
    }
    var idx = 0, lock = null;
    function goTo(i) {
      idx = Math.max(0, Math.min(slides.length - 1, i));
      lock = Date.now();
      var target = slides[idx].offsetLeft;
      track.scrollTo({ left: target, behavior: 'smooth' });
      setTimeout(function () { if (Math.abs(track.scrollLeft - target) > 4) track.scrollLeft = target; }, 450);
      setActive(idx);
    }
    function current() {
      var best = 0, dist = Infinity;
      slides.forEach(function (sl, n) {
        var d = Math.abs(sl.offsetLeft - track.scrollLeft);
        if (d < dist) { dist = d; best = n; }
      });
      return best;
    }

    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    var prev = gallery.querySelector('[data-lf-prev]'), next = gallery.querySelector('[data-lf-next]');
    if (prev) prev.addEventListener('click', function () { goTo(idx - 1); });
    if (next) next.addEventListener('click', function () { goTo(idx + 1); });

    var timer = null;
    track.addEventListener('scroll', function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        if (lock && Date.now() - lock < 700) return;   // eigener Sprung, nicht gegensteuern
        idx = current();
        setActive(idx);
      }, 120);
    }, { passive: true });
    setActive(0);
  });

  /* Sticky add-to-cart bar: appears once the buy box CTA scrolls out of view */
  var stickyBar = document.querySelector('[data-lf-sticky]');
  var watchTarget = document.querySelector('[data-lf-sticky-watch]');
  if (stickyBar && watchTarget && 'IntersectionObserver' in window) {
    var passed = false;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          passed = false;
        } else {
          passed = entry.boundingClientRect.top < 0;
        }
        stickyBar.classList.toggle('is-visible', passed);
      });
    }, { threshold: 0 });
    observer.observe(watchTarget);
    stickyBar.querySelector('[data-lf-sticky-jump]')?.addEventListener('click', function (e) {
      e.preventDefault();
      watchTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* Variant picker: update prices, availability line and buy button */
  var picker = document.querySelector('[data-lf-variant-picker]');
  if (picker) {
    var avail = document.querySelector('[data-lf-availability]');
    picker.addEventListener('change', function (e) {
      var input = e.target.closest('input[type="radio"]');
      if (!input) return;
      picker.querySelectorAll('.lf-variant').forEach(function (l) { l.classList.remove('is-active'); });
      input.closest('.lf-variant')?.classList.add('is-active');

      document.querySelectorAll('[data-lf-price]').forEach(function (el) {
        el.textContent = input.getAttribute('data-price');
      });

      var cmpEl = document.querySelector('[data-lf-compare]');
      var saveEl = document.querySelector('[data-lf-save]');
      var cmpVal = input.getAttribute('data-compare') || '';
      var saveVal = input.getAttribute('data-save') || '';
      if (cmpEl) { cmpEl.textContent = cmpVal; cmpEl.hidden = !cmpVal; }
      if (saveEl) { saveEl.textContent = saveVal; saveEl.hidden = !saveVal; }
      var badgeVal = input.getAttribute('data-badge') || '';
      document.querySelectorAll('[data-lf-badge]').forEach(function (el) { el.innerHTML = badgeVal; el.hidden = !badgeVal; });

      var available = input.getAttribute('data-available') === 'true';
      var low = input.getAttribute('data-low') === 'true';
      var digital = input.getAttribute('data-digital') === 'true';

      if (avail) {
        var dot = avail.querySelector('[data-lf-availability-dot]');
        var text = avail.querySelector('[data-lf-availability-text]');
        var state = available ? (low ? 'low' : 'ok') : 'out';
        if (dot) dot.className = 'lf-availability__dot lf-availability__dot--' + state;
        if (text) {
          if (!available) {
            text.textContent = avail.getAttribute('data-text-out');
          } else {
            text.textContent = avail.getAttribute(low ? 'data-text-low' : 'data-text-ok');
          }
        }
      }

      document.querySelectorAll('[data-lf-buy-btn]').forEach(function (btn) {
        btn.disabled = !available;
        btn.textContent = btn.getAttribute(available ? 'data-label-buy' : 'data-label-out');
      });
    });
  }

  /* Express buy: add selected variant to cart, go straight to checkout (PayPal sits on top there) */
  document.querySelectorAll('[data-lf-express]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = btn.closest('form');
      if (!form) return;
      var checked = form.querySelector('input[name="id"]:checked');
      var hidden = form.querySelector('input[name="id"]');
      var id = (checked || hidden) ? (checked || hidden).value : null;
      if (!id) return;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(id), quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = '/checkout';
      }).catch(function () {
        btn.disabled = false;
        form.submit();
      });
    });
  });

  /* Reviews page: "Mehr Bewertungen anzeigen" reveals the hidden rest */
  document.querySelectorAll('[data-lf-more-reviews]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('[data-lf-review-hidden]').forEach(function (el) {
        el.removeAttribute('hidden');
        el.removeAttribute('data-lf-review-hidden');
      });
      btn.setAttribute('hidden', 'hidden');
    });
  });

  /* Header: Klapp-Untermenü (Desktop) */
  document.querySelectorAll('[data-lf-nav-group]').forEach(function (group) {
    var btn = group.querySelector('[data-lf-nav-toggle]');
    if (!btn) return;
    var timer = null;
    var pinned = false;

    function open(state) {
      if (timer) { clearTimeout(timer); timer = null; }
      if (state) { group.setAttribute('data-open', ''); } else { group.removeAttribute('data-open'); pinned = false; }
      btn.setAttribute('aria-expanded', state ? 'true' : 'false');
    }
    function closeSoon() {
      if (pinned) return;
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { open(false); }, 180);
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (group.hasAttribute('data-open') && pinned) { open(false); return; }
      open(true);
      pinned = true;
    });
    group.addEventListener('mouseenter', function () { open(true); });
    group.addEventListener('mouseleave', closeSoon);
    group.addEventListener('focusin', function () { open(true); });
    group.addEventListener('focusout', function (e) {
      if (!group.contains(e.relatedTarget)) { pinned = false; open(false); }
    });
    document.addEventListener('click', function (e) {
      if (!group.contains(e.target)) { pinned = false; open(false); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { pinned = false; open(false); }
    });
  });

  /* Shop-Seite: Filter für Bundles und Bücher */
  (function () {
    var bar = document.querySelector('[data-lf-filter]');
    if (!bar) return;
    var chips = bar.querySelectorAll('[data-lf-kind]');
    var cards = document.querySelectorAll('.lf-pgrid__grid .lf-pcard');
    var count = document.querySelector('[data-lf-filter-count]');
    function apply(kind, push) {
      var shown = 0;
      cards.forEach(function (card) {
        var match = !kind || card.getAttribute('data-kind') === kind;
        if (match) { card.removeAttribute('hidden'); shown++; } else { card.setAttribute('hidden', 'hidden'); }
      });
      chips.forEach(function (c) {
        c.classList.toggle('is-active', c.getAttribute('data-lf-kind') === kind);
      });
      if (count) count.textContent = shown === 1 ? '1 Produkt' : shown + ' Produkte';
      if (push && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        if (kind) { url.searchParams.set('f', kind); } else { url.searchParams.delete('f'); }
        history.replaceState(null, '', url.toString());
      }
    }
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () { apply(chip.getAttribute('data-lf-kind'), true); });
    });
    var start = new URLSearchParams(window.location.search).get('f') || '';
    if (start !== 'bundle' && start !== 'buch') start = '';
    apply(start, false);
  })();

  /* Ankündigungsleiste: auf schmalen Bildschirmen rotieren */
  (function () {
    var bar = document.querySelector('[data-lf-announce]');
    if (!bar) return;
    var items = bar.querySelectorAll('.lf-announcement__item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      if (window.matchMedia('(min-width: 750px)').matches) return;
      items[i].setAttribute('data-lf-announce-hidden', '');
      i = (i + 1) % items.length;
      items[i].removeAttribute('data-lf-announce-hidden');
    }, 4200);
  })();

  /* Judge.me: Namen auf Vorname plus Anfangsbuchstabe kürzen */
  (function () {
    var sonderfaelle = { 'Raith Julia': 'Julia R.' };
    function kuerzen(roh) {
      var name = (roh || '').replace(/\s+/g, ' ').trim();
      if (!name) return roh;
      if (sonderfaelle[name]) return sonderfaelle[name];
      if (name === 'Anonym' || name === 'Anonymous') return name;
      var teile = name.split(' ');
      if (teile.length < 2) return name;
      var nachname = teile[teile.length - 1];
      return teile[0] + ' ' + nachname.charAt(0).toUpperCase() + '.';
    }
    var auswahl = '.jdgm-rev__author, .jdgm-rev-widg__author, .jdgm-carousel-item__reviewer-name, .jdgm-featured-reviews__author, .jdgm-review__author';
    function anwenden(wurzel) {
      var knoten = (wurzel || document).querySelectorAll ? (wurzel || document).querySelectorAll(auswahl) : [];
      for (var i = 0; i < knoten.length; i++) {
        var el = knoten[i];
        if (el.hasAttribute('data-lf-name')) continue;
        var kurz = kuerzen(el.textContent);
        if (kurz !== el.textContent) el.textContent = kurz;
        el.setAttribute('data-lf-name', '');
      }
    }
    anwenden(document);
    var beobachter = new MutationObserver(function (aenderungen) {
      for (var i = 0; i < aenderungen.length; i++) {
        var neue = aenderungen[i].addedNodes;
        for (var j = 0; j < neue.length; j++) {
          if (neue[j].nodeType === 1) anwenden(neue[j]);
        }
      }
      anwenden(document);
    });
    beobachter.observe(document.documentElement, { childList: true, subtree: true });
  })();

  /* Videos in der Produktgalerie: stumm abspielen, sobald sie sichtbar sind */
  (function () {
    var videos = document.querySelectorAll('video[data-lf-video]');
    if (!videos.length || !('IntersectionObserver' in window)) return;
    var beobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && e.intersectionRatio > 0.6) {
          if (v.preload === 'none') v.preload = 'auto';
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: [0, 0.6, 1] });
    videos.forEach(function (v) { v.muted = true; beobachter.observe(v); });
  })();

  /* Warenkorb-Vorschlaege: direkt hinzufuegen, ohne Seitenwechsel */
  (function () {
    var knoepfe = document.querySelectorAll('[data-lf-add]');
    if (!knoepfe.length) return;
    knoepfe.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = Number(btn.getAttribute('data-lf-add'));
        if (!id || btn.disabled) return;
        var text = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Wird hinzugefügt …';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/cart';
        }).catch(function () {
          btn.disabled = false;
          btn.textContent = text;
        });
      });
    });
  })();
})();
document.addEventListener('DOMContentLoaded', function () {
  /* Gleichfarbige Nachbar-Sektionen markieren (Konturlinien-Trenner, CSS .lf-same-bg) */
  (function () {
    var last = null;
    document.querySelectorAll('.lf-section--paper, .lf-section--white').forEach(function (sec) {
      var bg = sec.classList.contains('lf-section--paper') ? 'paper' : 'white';
      if (last === bg) sec.classList.add('lf-same-bg');
      last = bg;
    });
  })();
});
